module.exports = __webpack_public_path__ + "img/icones_tooltip.042db141.png";